import { createContext } from 'react';

export const WidgetVisibilityContext = createContext({
  isVisible: true,
  hasEnteredViewport: true,
  pollingActive: true,
});
